import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import ToastIcon from "../toast-icon/ToastIcon";
import styles from "./toast-item.module.scss";
import sharedStyles from "../../toast.module.scss";

const TRANSITION_DURATION = 500;
const TOAST_DURATION = 6000;
const TOAST_VISIBLE_TIMER_DURATION = 1000;

const ToastItem = ({ storeRef, type, message, id }) => {
  const removeToast = storeRef((state) => state.removeToast);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let removeTimer;
    const timer = setTimeout(() => {
      setVisible(false);
      removeTimer = setTimeout(() => {
        removeToast(id);
      }, TRANSITION_DURATION);
    }, TOAST_DURATION);
    return () => {
      clearTimeout(timer);
      if (removeTimer) {
        clearTimeout(removeTimer);
      }
    };
  }, [id, removeToast]);

  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, TOAST_VISIBLE_TIMER_DURATION);
  }, []);

  return (
    <div
      className={`${styles.toastItem} ${styles[type]} ${visible ? styles.visible : ""} flex align-center between`}
    >
      <ToastIcon type={type} />
      <div className={`${styles.toastText} pl-4 mr-4 grow`}>{message}</div>
      <FontAwesomeIcon
        onClick={() => removeToast(id)}
        className={sharedStyles.closeIcon}
        icon="times"
      />
    </div>
  );
};

export default ToastItem;
